export const Colors = {
  primary: '#D77A52',
  primaryDark: '#5B2D1F',
  primaryLight: '#9FD8DA',
  accent: '#5B2D1F',
  accentDark: '#3E1A10',
  cream: '#FBF6EF',
  background: '#F7FAFC',
  surface: '#FFFFFF',
  surfaceAlt: '#EEF4F7',
  border: '#D7E2E8',
  warmBorder: '#E5DDD3',
  textPrimary: '#0F2A35',
  textSecondary: '#4B6B79',
  textOnPrimary: '#FFFFFF',
  danger: '#B0303A',
  dangerSoft: '#FCE7EA',
  warning: '#B07A1F',
  warningSoft: '#FFF4DF',
  success: '#1F7A4A',
  successSoft: '#E4F4EB',
  neutral: '#5C6B72',
  neutralSoft: '#E8ECEE',
  disclaimerBg: '#FFF4DF',
  disclaimerBorder: '#E0B96F',
  disclaimerText: '#5C3B0E',
};

export const SeverityColors = {
  severe: { bg: Colors.dangerSoft, text: Colors.danger, border: Colors.danger },
  moderate: { bg: Colors.warningSoft, text: Colors.warning, border: Colors.warning },
  uncertain: { bg: Colors.neutralSoft, text: Colors.neutral, border: Colors.neutral },
  minor: { bg: Colors.successSoft, text: Colors.success, border: Colors.success },
  none: { bg: Colors.successSoft, text: Colors.success, border: Colors.success },
};

export const SEVERITY_ORDER = {
  none: 0,
  minor: 1,
  uncertain: 2,
  moderate: 3,
  severe: 4,
};

export const SEVERITY_LABEL = {
  severe: 'Severe',
  moderate: 'Moderate',
  uncertain: 'Uncertain',
  minor: 'Minor',
  none: 'No interaction',
};
